module.exports = __webpack_public_path__ + "img/cases_banner_m.e2a71363.png";